import { twJoin } from "tailwind-merge"
import { useState } from "react"
import Modal from "./Modal"
import EditAccount from "../Partials/EditAccount"
import HelpSupport from "../Partials/HelpSupport"
import SideBarCollapsible from "./SideBarCollapsible"
import { auth } from "../services/auth"
import { SideBarButton } from "./SideBarButton"
import { generatePlanLinks } from "../helpers"
import { useAtom } from "jotai"
import { isGuideAtom, isGuideAdminAtom } from "../state"

function SideBar({
  filteredPlans,
  onSearchChange,
  sideBarOpen,
  setSideBarOpen,
}) {
  const [accountOpen, setAccountOpen] = useState(false)
  const [helpOpen, setHelpOpen] = useState(false)
  const [isGuideAdmin] = useAtom(isGuideAdminAtom)
  const [isGuide] = useAtom(isGuideAtom)
  const onAccount = () => {
    setAccountOpen(true)
  }

  const onHelp = () => {
    setHelpOpen(true)
  }

  const onLogout = () => {
    auth.logout()
  }

  return (
    <>
      <div
        className={twJoin(
          "relative flex h-screen w-full flex-col border-r border-r-neutral-400 transition-all duration-300 ease-in-out",
          sideBarOpen ? "md:max-w-[250px]" : "max-w-0",
        )}
      >
        {sideBarOpen && (
          <>
            <h1 className="mb-8 mt-8 px-8 text-center text-2xl font-bold text-brand">
              My Mentor Circle Plans
            </h1>
            <div className="relative">
              <i className="fa-solid fa-search absolute left-4 top-1/2 -translate-y-1/2 transform text-neutral-400"></i>
              <input
                onChange={onSearchChange}
                type="text"
                placeholder=""
                className="w-full border border-neutral-300 p-4 px-12 text-xl focus:border-t-neutral-400 focus:outline-0"
              />
            </div>
            <ul className="flex-1 overflow-auto">
              {filteredPlans.map(plan => (
                <li key={plan.token + "-" + plan.status} className="w-full">
                  <SideBarCollapsible
                    token={plan.token}
                    title={plan.name || "Plan"}
                    links={generatePlanLinks(plan)}
                    setSideBarOpen={setSideBarOpen}
                  />
                </li>
              ))}
            </ul>

            <SideBarButton
              title={isGuide || isGuideAdmin ? "Guide Dashboard" : "Admin Dashboard"}
              route="/admin"
              visibleToGuide={true}
              adminOnly={true}
              iconClassName={"fa-solid fa-chart-line"}
              firstOfGroup={true}
            />
            <SideBarButton
              title="Add a Plan"
              route="/plan/new"
              adminOnly={false}
              iconClassName={"fa-solid fa-plus"}
              firstOfGroup={true}
            />
            <SideBarButton
              title="Resources"
              route="/resources"
              adminOnly={false}
              iconClassName={"fa-solid fa-book"}
            />
            <SideBarButton
              title="Help & Support"
              adminOnly={false}
              iconClassName={"fa-solid fa-circle-question"}
              onClick={onHelp}
            />
            <SideBarButton
              title="Account"
              adminOnly={false}
              iconClassName={"fa-solid fa-gear"}
              onClick={onAccount}
            />

            <button
              className="group flex items-center gap-4 border-t border-t-neutral-200 px-4 py-2 text-sm font-bold uppercase leading-5 text-brand"
              onClick={onLogout}
            >
              <i className="fa-solid fa-sign-out-alt rounded p-2 text-brand"></i>
              Logout
            </button>
            <Modal isOpen={accountOpen} setIsOpen={setAccountOpen} width="md:max-w-xl">
              <EditAccount onAccountEdited={() => setAccountOpen(false)} />
            </Modal>
            <Modal isOpen={helpOpen} setIsOpen={setHelpOpen} width="md:max-w-xl">
              <HelpSupport />
            </Modal>
          </>
        )}
        <button
          className="absolute top-[24px] z-10 rounded-r-lg bg-brand py-3 pl-2 pr-3 transition-transform duration-300 ease-in-out md:left-full md:top-1/2 md:-translate-y-1/2"
          onClick={() => {
            setSideBarOpen(!sideBarOpen)
          }}
        >
          <i
            className={twJoin(
              "fa-solid fa-chevron-right text-lg text-white transition-transform duration-300",
              sideBarOpen ? "fa-rotate-180" : "",
            )}
          ></i>
        </button>
      </div>
    </>
  )
}

export default SideBar
